import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

const URL_REGEX = /(\bhttps?:\/\/[^\s<]+|\bwww\.[^\s<]+)/gi;
const TRAILING_PUNCT = /[).,;:!?\]}»"']+$/;

@Pipe({ name: 'semLinkify' })
export class SemLinkifyPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string | null | undefined): SafeHtml {
    if (value == null) { return ''; }

    const text = String(value);
    let result = '';
    let lastIndex = 0;

    text.replace(URL_REGEX, (match, _g1, offset: number) => {
      result += this.escape(text.substring(lastIndex, offset));

      let trailing = '';
      const trimmed = match.replace(TRAILING_PUNCT, (t) => { trailing = t; return ''; });

      const href = trimmed.startsWith('www.') ? 'https://' + trimmed : trimmed;
      result += '<a href="' + this.escapeAttr(href) + '" target="_blank" rel="noopener noreferrer">'
        + this.escape(trimmed) + '</a>' + this.escape(trailing);

      lastIndex = offset + match.length;
      return match;
    });

    result += this.escape(text.substring(lastIndex));
    result = result.replace(/\n/g, '<br>');

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  private escape(s: string): string {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeAttr(s: string): string {
    return this.escape(s);
  }
}
